import axios from "axios"
const baseUrl = `${process.env.REACT_APP_BASE_URL}info/BCUF9UTaTeeiHRTx4AWY2ECb29NNAhMHNG3W4kdtCAj3sD7bFA`

export const updateBotFlow = async () => {
    const response = await axios.get(baseUrl);
    return response
}